import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import queryString from 'query-string';

import useUserAccount from 'hooks/useUserAccount';
import AdminOnboarding from 'screens/components/AdminOnboarding';

const AdminOnboardingContainer = () => {
  const [isShowOnboarding, setIsShowOnboarding] = useState(false);
  const user = useUserAccount();
  const history = useHistory();

  const queryParams = queryString.parse(location.search) as {
    email?: string;
    name?: string;
    lastName?: string;
  };

  const { email, name, lastName } = queryParams;

  useEffect(() => {
    if (user?.onboardingDone) {
      history.push('/corporate/dashboard');
    } else {
      setIsShowOnboarding(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // TODO: check dependencies or refactor

  return <>{isShowOnboarding && <AdminOnboarding adminEmail={email} adminName={name} adminLastName={lastName} />}</>;
};

export default AdminOnboardingContainer;
